import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";


const PhpLesson16 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        $servername = "localhost";
        $username = "your_username";
        $password = "your_password";
        $dbname = "your_database_name";

        //Create connection
        $conn = new mysqli($servername, $username, $password, $dbname);

        // Check connection
        if ($conn->connect_error) {
            die("Connection failed: " .$conn->connect_error);
        }
        echo "Connected Successfully";

        `
      );

      const code1 = (
        'text',
        `
        <?php
        $servername = "localhost";
        $username = "your_username"; // Replace with yours
        $password = "your_password"; // Replace with yours
        $dbname = "your_database_name"; // Replace with yours

        //Create connection
        $conn = mysqli_connect($servername, $username, $password, $dbname);

        // Check connection
        if (!$conn) {
            die("Connection failed: " . mysqli_connect_error);
        }
        echo "Connected Successfully";
        ?>
        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Connect to Database</strong></h3>

       <h5 class="text-danger">a.) Using Object Oriented Programming Method</h5>

    <p>To connect to a database using PHP <b>OBJECT ORIENTED PROGRAMMING</b> style, you can take the following steps:</p>
    <p> 1. Create a new PHP file and open it in your favourite text editor.</p>
    <p> 2. Use the following code to create a database connection.</p>
    <CopyBlock
                        language={"php"}
                        text={code}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />
     <p>Replace <b>`localhost`</b> with the name of your server, <b>`your_username`</b> with your MySQL username, <b>`your_password`</b> with your MySQL password, and <b>`your_database_name`</b> with the name of the database you want to connect to.</p>
        <p>3. Save the file with a <b>.php</b> extension and upload it to your web server.</p>
        <p>4. Open the file in a web browser to test the database connection. If the connection is successful, you should see the message <b>`Connected successfully`</b> displayed on the page.</p>
        <h4>b.)Using  Procedural Method</h4>
        <p>To use the procedural method, we first have to create a connection to the database using <b class="text-danger">`mysqli_connet()` function and then check if the connection is successful.</b></p>

        <CopyBlock
                        language={"php"}
                        text={code1}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />          <p>Note: Replace <b class="text-danger">`yourusername`</b>, <b class="text-danger">`yourpassword`</b>, and <b class="text-danger">`yourdatabase`</b> with your actual database credentials.</p>





    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson16
